import { LogoMark } from "./Logo";

const WORDS = [
  "Quietly organized for the moment it matters",
  "Filed, dated and ready",
  "Encrypted at rest",
  "No trackers, no ads",
  "Reminded in time",
  "A plan your family can follow",
];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center gap-10 pr-10" aria-hidden={hidden || undefined}>
    {WORDS.map((w) => (
      <span key={w} className="flex items-center gap-10 whitespace-nowrap">
        <span className="font-serif italic text-3xl sm:text-5xl text-[#1F1A17]">{w}</span>
        <LogoMark className="h-6 w-6 text-[#B4532A]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="relative overflow-hidden border-y border-[#E8DDD3] bg-[#F3ECE4] py-8 sm:py-10">
    <div className="hv-marquee flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
